<script>
    import {Html5Qrcode} from "html5-qrcode"
    import { Button, Icon, Dialog, TextField } from 'svelte-materialify';
    import { mdiCamera, mdiArrowLeft } from '@mdi/js';
    import { provetta, mode } from '../store';
    
    export let window;
    export let isVisible;
    export let value;

    $: isVisible, startCamera();
    
    let html5QrCode, _mode;

    mode.subscribe(val => _mode = val);

    let isCameraActive = null;

    let idManual = "";
    let isManualSelectorActive = false;

    const rules = [
        v => v.length >= 5 || "Troppo corto",
        v => {
            if(/[A-Z : a-z]{2}-[A-Z : a-z : 0-9]{5,}/gm.test(v))
                return true;
            return "Questo non è un ID compatibile"
        }
    ];

    function startCamera() {

        if(!isVisible)
            return;

        if(!html5QrCode)
            html5QrCode = new Html5Qrcode("frames")

        html5QrCode.start(
        { facingMode: "environment" }, 
        {
            fps: 24,
            qrbox: { width: 300, height: 80, } 
        },
        (decodedText, decodedResult) => {
            checkCode(decodedText);
        })
        .then(() => {
            isCameraActive = true;
        })
        .catch((err) => {
            isCameraActive = false;
            console.log(err);
        });
    }

    function checkCode(code) {

        if(!(/[A-Z : a-z]{2}-[A-Z : a-z : 0-9]{5,}/gm.test(code)))
            return;

        console.log(code);

        provetta.set(code);

        if(_mode === "end")
            value = 6;
        else
            value = 3;

        stop();

    }

    function stop() {
        if(!html5QrCode)
            return;
        html5QrCode.stop().then((ignore) => {
            // QR Code scanning is stopped.
        }).catch((err) => {
            // Stop failed, handle it.
        });
    }

</script>

<main>    
        
    <div class="pa-3 permission-box white rounded-lg elevation-1">

        <TextField {rules} bind:value={idManual} filled color="green" class="mb-3">
            ID provetta
        </TextField>

        <Button disabled={!idManual} class="green" depressed block on:click={() => checkCode(idManual)}>
            Conferma
        </Button>

    </div>

    <div id="camera-viewer" isVisible={isCameraActive}>

        <div id="frames"></div>

    </div>

    <div class="action-container pa-3">

        {#if isCameraActive}
        
            <Button text class="green-text" on:click={() => isManualSelectorActive = true}>
                Inserisci manualmente
            </Button>

        {/if}

        <Button rounded depressed class="green" on:click={() => {
            window.previous();
            if(html5QrCode)
                stop();
        }}>
            <Icon path={mdiArrowLeft} class="mr-2" />
            Torna indietro
        </Button>
        
    </div>

    <Dialog class="pa-3" bind:active={isManualSelectorActive}>

        <TextField {rules} bind:value={idManual} filled color="green" class="mb-6">
            ID provetta
        </TextField>

        <Button disabled={!idManual} class="green" depressed block on:click={() => checkCode(idManual)}>
            Conferma
        </Button>

        <Button outlined block class="red-text" depressed on:click={() => isManualSelectorActive = false}>
            Chiudi
        </Button>

    </Dialog>

</main>

<style>

    main {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        display: grid;
        place-items: center;
        overflow: hidden;
    }

    main > .permission-box {
        display: grid;
        place-items: center;
        max-width: 400px;
    }

    main > .permission-box > .description {
        text-align: justify;
    }

    main .camera-icon {
        display: grid;
        place-items: center;
    }

    #camera-viewer {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        display: grid;
        place-items: center;
        background-color: #000;
    }

    #camera-viewer[isVisible=false] {
        visibility: hidden;
        pointer-events: none;
    }

    #frames {
        height: auto;
        width: 100%;
    }

    main > .action-container {
        position: absolute;
        width: 100%;
        height: auto;
        left: 0;
        bottom: 0;
        display: grid;
        place-items: center;
    }

    main > .camera-selector {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: auto;
        display: grid;
        place-items: center;
    }

    /* :global(#camera-viewer > video) {
        width: 100% !important;
        height: 100% !important;
    } */

</style>